import AppMessage from '../../models/AppMessage'

// TODO: Will be accessed from config !!!
const debug = false
const moduleName = 'ADMIN-DATA'

export default {

  // ---------------------------------------------------------------------------
  // Change assigned driver (Route)
  // ---------------------------------------------------------------------------
  async changeAssignedDriver (context, { routeId, newDriverUserId }) {
    const { dispatch, commit } = context

    try {
      const updatedRoute = await dispatch('dataApi', {
        method: 'post',
        uri: `/route/${routeId}/change-driver`,
        opts: {
          bodyData: { user_id: newDriverUserId }
        }
      })
      if (debug) console.log(`[${moduleName}] Changed assigned driver for route:`, updatedRoute)

      // Sync into data registries
      commit('syncDataItem', { resource: 'activeDelivery', data: updatedRoute })
      commit('syncItemEditing', { resource: 'activeDelivery', data: updatedRoute })

      // Register feedback message
      const message = new AppMessage({
        source: updatedRoute,
        status_code: 200,
        severity: 'success',
        text: `Assigned Driver for ${routeId} was changed.`
      })
      dispatch('registerMessageForItemEditing', { resource: 'activeDelivery', message })

      // Return updated route
      return updatedRoute
    } catch (error) {
      if (debug) console.log(`[${moduleName}] Error changing driver for route ${routeId} =>`, error)

      // Register feedback message
      const message = new AppMessage({
        source: error,
        status_code: error.status,
        severity: 'error',
        text: error.messages
      })
      dispatch('registerMessageForItemEditing', { resource: 'activeDelivery', message })

      throw error
    }
  },

  // ---------------------------------------------------------------------------
  // Start delivery (Route)
  // ---------------------------------------------------------------------------
  async startDelivery (context, route = {}) {
    const { dispatch, commit } = context
    const routeId = route.id

    try {
      const updatedRoute = await dispatch('dataApi', {
        method: 'post',
        uri: `/route/${routeId}/start`
      })
      if (debug) console.log(`[${moduleName}] Started route:`, updatedRoute)

      // Sync into data registries
      commit('syncDataItem', { resource: 'activeDelivery', data: updatedRoute })
      commit('syncItemEditing', { resource: 'activeDelivery', data: updatedRoute })

      // Register feedback message
      const message = new AppMessage({
        source: updatedRoute,
        status_code: 200,
        severity: 'success',
        text: `Delivery ${route.name} was started.`
      })
      dispatch('registerMessageForItemEditing', { resource: 'activeDelivery', message })

      // Return updated route
      return updatedRoute
    } catch (error) {
      if (debug) console.log(`[${moduleName}] Error starting route ${routeId} =>`, error)

      // Register feedback message
      const message = new AppMessage({
        source: error,
        status_code: error.status,
        severity: 'error',
        text: error.messages
      })
      dispatch('registerMessageForItemEditing', { resource: 'activeDelivery', message })

      throw error
    }
  },

  // ---------------------------------------------------------------------------
  // Claim vehicle
  // ---------------------------------------------------------------------------
  async claimVehicle (context, { routeId, odometerReading }) {
    const { dispatch, commit } = context
    if (debug) console.log(`[${moduleName}] Claiming vehicle for route ${routeId}`)

    try {
      // Update route
      const updatedRoute = await dispatch('dataApi', {
        method: 'post',
        uri: `/route/${routeId}/claim-vehicle`,
        opts: {
          bodyData: { odometer_reading: odometerReading }
        }
      })
      if (debug) console.log(`[${moduleName}] Updated route:`, updatedRoute)

      // Sync into data registries
      commit('syncDataItem', { resource: 'activeDelivery', data: updatedRoute })
      commit('syncItemEditing', { resource: 'activeDelivery', data: updatedRoute })

      // Register feedback message
      const message = new AppMessage({
        source: updatedRoute,
        status_code: 200,
        severity: 'success',
        text: `Driver has claimed vehicle for delivery ${updatedRoute.name}.`
      })
      dispatch('registerMessageForItemEditing', { resource: 'activeDelivery', message })

      // Return updated route
      return updatedRoute
    } catch (error) {
      if (debug) console.log(`[${moduleName}] Error claiming vehicle for route ${routeId} =>`, error)
      throw error
    }
  },

  // ---------------------------------------------------------------------------
  // Return to Lot
  // ---------------------------------------------------------------------------
  async returnToLot (context, route = {}) {
    const { dispatch, commit } = context
    const routeId = route.id

    try {
      const updatedRoute = await dispatch('dataApi', {
        method: 'post',
        uri: `/route/${routeId}/return-to-lot`
      })
      if (debug) console.log(`[${moduleName}] Updated route:`, updatedRoute)

      // Sync into data registries
      commit('syncDataItem', { resource: 'activeDelivery', data: updatedRoute })
      commit('syncItemEditing', { resource: 'activeDelivery', data: updatedRoute })

      // Register feedback message
      const message = new AppMessage({
        source: updatedRoute,
        status_code: 200,
        severity: 'success',
        text: `Driver is returning to lot from route ${route.name}.`
      })
      dispatch('registerMessageForItemEditing', { resource: 'activeDelivery', message })

      // Return updated route
      return updatedRoute
    } catch (error) {
      if (debug) console.log(`[${moduleName}] Error updating route ${routeId} =>`, error)

      // Register feedback message
      const message = new AppMessage({
        source: error,
        status_code: error.status,
        severity: 'error',
        text: error.messages
      })
      dispatch('registerMessageForItemEditing', { resource: 'activeDelivery', message })

      throw error
    }
  },

  // ---------------------------------------------------------------------------
  // Complete delivery (Route)
  // ---------------------------------------------------------------------------
  async completeDelivery (context, { routeId, odometerReading }) {
    const { dispatch, commit } = context

    try {
      const updatedRoute = await dispatch('dataApi', {
        method: 'post',
        uri: `/route/${routeId}/complete`,
        opts: {
          bodyData: { odometer_reading: odometerReading }
        }
      })
      if (debug) console.log(`[${moduleName}] Completed route:`, updatedRoute)

      // Sync into data registries
      commit('syncDataItem', { resource: 'activeDelivery', data: updatedRoute })
      commit('syncItemEditing', { resource: 'activeDelivery', data: updatedRoute })

      // Register feedback message
      const message = new AppMessage({
        source: updatedRoute,
        status_code: 200,
        severity: 'success',
        text: `Delivery ${updatedRoute.name} was completed.`
      })
      dispatch('registerMessageForItemEditing', { resource: 'activeDelivery', message })

      // Return updated route
      return updatedRoute
    } catch (error) {
      if (debug) console.log(`[${moduleName}] Error completing route ${routeId} =>`, error)

      // Register feedback message
      const message = new AppMessage({
        source: error,
        status_code: error.status,
        severity: 'error',
        text: error.messages
      })
      dispatch('registerMessageForItemEditing', { resource: 'activeDelivery', message })

      throw error
    }
  },

  // ---------------------------------------------------------------------------
  // Confirm order code
  // ---------------------------------------------------------------------------
  async confirmOrderCode (context, { orderId, code }) {
    const { dispatch, commit } = context

    try {
      // Perform code confirmation
      const updatedOrder = await dispatch('dataApi', {
        method: 'post',
        uri: `/order/${orderId}/confirm-code`,
        opts: {
          bodyData: { confirmation_code: code }
        }
      })
      if (debug) console.log(`[${moduleName}] Confirmed code for order:`, updatedOrder)

      // Sync into data registries
      commit('syncDataItem', { resource: 'activeDelivery', nested: 'orders', data: updatedOrder })
      commit('syncItemEditing', { resource: 'activeDelivery', nested: 'orders', data: updatedOrder })

      // Return updated order
      return updatedOrder
    } catch (error) {
      if (debug) console.log(`[${moduleName}] Error confirming code for order ${orderId} =>`, error)
      throw error
    }
  },

  // ---------------------------------------------------------------------------
  // Confirm ordered items
  // ---------------------------------------------------------------------------
  async confirmOrderedItems (context, { orderId }) {
    const { dispatch, commit } = context

    try {
      // Perform items checked confirmation
      const updatedOrder = await dispatch('dataApi', {
        method: 'post',
        uri: `/order/${orderId}/items-checked`
      })
      if (debug) console.log(`[${moduleName}] Confirmed items for order:`, updatedOrder)

      // Sync into data registries
      commit('syncDataItem', { resource: 'activeDelivery', nested: 'orders', data: updatedOrder })
      commit('syncItemEditing', { resource: 'activeDelivery', nested: 'orders', data: updatedOrder })

      // Return updated order
      return updatedOrder
    } catch (error) {
      if (debug) console.log(`[${moduleName}] Error confirming items for order ${orderId} =>`, error)
      throw error
    }
  },

  // ---------------------------------------------------------------------------
  // Record driver signed at pickup
  // ---------------------------------------------------------------------------
  async recordDriverSignatureAtPickup (context, { orderId }) {
    const { dispatch, commit } = context

    try {
      // Update order timestamp
      const updatedOrder = await dispatch('dataApi', {
        method: 'post',
        uri: `/order/${orderId}`,
        opts: {
          bodyData: { driver_pickup_signed_at: new Date().toISOString() }
        }
      })
      if (debug) console.log(`[${moduleName}] Driver signed at pickup for order:`, updatedOrder)

      // Sync into data registries
      commit('syncDataItem', { resource: 'activeDelivery', nested: 'orders', data: updatedOrder })
      commit('syncItemEditing', { resource: 'activeDelivery', nested: 'orders', data: updatedOrder })

      // Return updated order
      return updatedOrder
    } catch (error) {
      if (debug) console.log(`[${moduleName}] Error recording driver pickup signature for order ${orderId} =>`, error)
      throw error
    }
  },

  // ---------------------------------------------------------------------------
  // Set order: Picked-up
  // ---------------------------------------------------------------------------
  async setOrderPickedUp (context, order = {}) {
    const { dispatch, commit } = context
    const orderId = order.id

    try {
      const updatedOrder = await dispatch('dataApi', {
        method: 'post',
        uri: `/order/${orderId}/pickup`
      })
      if (debug) console.log(`[${moduleName}] Updated order:`, updatedOrder)

      // Sync into data registries
      commit('syncDataItem', { resource: 'activeDelivery', nested: 'orders', data: updatedOrder })
      commit('syncItemEditing', { resource: 'activeDelivery', nested: 'orders', data: updatedOrder })

      // Register feedback message
      const message = new AppMessage({
        source: updatedOrder,
        status_code: 200,
        severity: 'success',
        text: `Driver has picked up order ${order.order_number}.`
      })
      dispatch('registerMessageForItemEditing', { resource: 'activeDelivery', message })

      // Return updated order
      return updatedOrder
    } catch (error) {
      if (debug) console.log(`[${moduleName}] Error picking up order ${order.order_number} =>`, error)

      // Register feedback message
      const message = new AppMessage({
        source: error,
        status_code: error.status,
        severity: 'error',
        text: error.messages
      })
      dispatch('registerMessageForItemEditing', { resource: 'activeDelivery', message })

      throw error
    }
  },

  // ---------------------------------------------------------------------------
  // Reject order
  // ---------------------------------------------------------------------------
  async rejectOrder (context, { orderId, agentName, shipperNotes, receiverNotes, driverNotes }) {
    const { dispatch, commit } = context

    try {
      const updatedOrder = await dispatch('dataApi', {
        method: 'post',
        uri: `/order/${orderId}/reject`,
        opts: {
          bodyData: {
            agent_name: agentName,
            shipper_notes: shipperNotes,
            receiver_notes: receiverNotes,
            driver_notes: driverNotes
          }
        }
      })
      if (debug) console.log(`[${moduleName}] Updated order:`, updatedOrder)

      // Sync into data registries
      commit('syncDataItem', { resource: 'activeDelivery', nested: 'orders', data: updatedOrder })
      commit('syncItemEditing', { resource: 'activeDelivery', nested: 'orders', data: updatedOrder })

      // Register feedback message
      const message = new AppMessage({
        source: updatedOrder,
        status_code: 200,
        severity: 'success',
        text: `Order ${updatedOrder.order_number} has been flagged as rejected.`
      })
      dispatch('registerMessageForItemEditing', { resource: 'activeDelivery', message })

      // Return updated order
      return updatedOrder
    } catch (error) {
      if (debug) console.log(`[${moduleName}] Error rejecting order ${orderId} =>`, error)

      // Register feedback message
      const message = new AppMessage({
        source: error,
        status_code: error.status,
        severity: 'error',
        text: error.messages
      })
      dispatch('registerMessageForItemEditing', { resource: 'activeDelivery', message })

      throw error
    }
  },

  // ---------------------------------------------------------------------------
  // Record driver signed at delivery
  // ---------------------------------------------------------------------------
  async recordDriverSignatureAtDelivery (context, { orderId }) {
    const { dispatch, commit } = context

    try {
      // Update order timestamp
      const updatedOrder = await dispatch('dataApi', {
        method: 'post',
        uri: `/order/${orderId}`,
        opts: {
          bodyData: { driver_deliver_signed_at: new Date().toISOString() }
        }
      })
      if (debug) console.log(`[${moduleName}] Driver signed at delivery for order:`, updatedOrder)

      // Sync into data registries
      commit('syncDataItem', { resource: 'activeDelivery', nested: 'orders', data: updatedOrder })
      commit('syncItemEditing', { resource: 'activeDelivery', nested: 'orders', data: updatedOrder })

      // Return updated order
      return updatedOrder
    } catch (error) {
      if (debug) console.log(`[${moduleName}] Error recording driver delivery signature for order ${orderId} =>`, error)
      throw error
    }
  },

  // ---------------------------------------------------------------------------
  // Set order: Delivered
  // ---------------------------------------------------------------------------
  async setOrderDelivered (context, { orderId, agentName, agentLicenseNumber, agentLicenseExpiration, deliveryInfo, driverNotes }) {
    const { dispatch, commit } = context

    try {
      const updatedOrder = await dispatch('dataApi', {
        method: 'post',
        uri: `/order/${orderId}/deliver`,
        opts: {
          bodyData: {
            agent_name: agentName,
            agent_fa_license_number: agentLicenseNumber,
            agent_fa_license_expiration: agentLicenseExpiration,
            delivery_info: deliveryInfo,
            driver_notes: driverNotes
          }
        }
      })
      if (debug) console.log(`[${moduleName}] Updated order:`, updatedOrder)

      // Sync into data registries
      commit('syncDataItem', { resource: 'activeDelivery', nested: 'orders', data: updatedOrder })
      commit('syncItemEditing', { resource: 'activeDelivery', nested: 'orders', data: updatedOrder })

      // Register feedback message
      const message = new AppMessage({
        source: updatedOrder,
        status_code: 200,
        severity: 'success',
        text: `Driver has delivered order ${updatedOrder.order_number}.`
      })
      dispatch('registerMessageForItemEditing', { resource: 'activeDelivery', message })

      // Return updated order
      return updatedOrder
    } catch (error) {
      if (debug) console.log(`[${moduleName}] Error delivering order ${orderId} =>`, error)

      // Register feedback message
      const message = new AppMessage({
        source: error,
        status_code: error.status,
        severity: 'error',
        text: error.messages
      })
      dispatch('registerMessageForItemEditing', { resource: 'activeDelivery', message })

      throw error
    }
  }

}
